import React, { useEffect, useRef, useState } from 'react';
import { Navigate, useNavigate } from "react-router";
import { User } from '../../Entities/User.ts';
import { LoadingAnimation } from '../../Utils/Progress/progress-component';
import { Modal } from '../../Utils/Modal/modal-component';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import idanCover from '../../Assets/login_img.png'
import ThemeToggler from '../../Utils/Theme/theme-toggeler-component';
import * as authActions from '../../Redux/Auth/AuthActions';
import Navbar from '../../Utils/Navbar/navbar-component.js';
import './Login.css';

function Login() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const gsiButton = useRef(null);

    const [email, setEmail] = useState(Cookies.get('email') || '');
    const [password, setPassword] = useState(Cookies.get('password') || '');
    const [remember, setRemember] = useState(Cookies.get('remember') || false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const loading = useSelector((state) => state.loading);
    let currentRoute = useSelector((state) => state.auth.currentRoute);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    useEffect(() => {
        dispatch(authActions.isLoggedIn());
        dispatch(authActions.disableSignUp());
    }, [dispatch]);

    useEffect(() => {
        try {
            window.google.accounts.id.initialize({
                client_id: process.env.REACT_APP_INFRA_GOOGLE_CLIENT_ID,
                callback: (res) => dispatch(authActions.handleLoginWithGoogle(res)),
                // ux_mode: "redirect"
            });

            window.google.accounts.id.renderButton(
                gsiButton.current,
                { theme: "outline", size: "large", logo_alignment: "center", text: "signin_with", width: 304 }
                // {theme: "filled_black", size: "large", logo_alignment: "center", text: "signin_with", width: 304 }
            );

            // setTimeout(() => {
            //     if (currentRoute.toLowerCase() === '/login') {
            //         window.google.accounts.id.prompt();
            //     }
            // }, 2000);
        }
        catch (e) { console.log(e); }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, gsiButton.current, isAuthenticated]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const user = new User(email, password);
        dispatch(authActions.login(user));
        dispatch(authActions.isLoggedIn());
        if (remember) {
            Cookies.set('remember', true, { expires: 7 });
            Cookies.set('email', user.email, { expires: 7 });
            Cookies.set('password', user.password, { expires: 7 });
        }
        else {
            Cookies.remove('remember');
            Cookies.remove('email');
            Cookies.remove('password');
        }
    };


    if (isAuthenticated) {
        if (currentRoute.toLowerCase() === '/login' || currentRoute === '/') {
            currentRoute = '/home';
        }
        return <Navigate to={currentRoute} replace />
    }

    <Modal expand={loading.visible}>
        <LoadingAnimation loadingMessage={loading.message} />
    </Modal>

    return (
        <div>
            {/* <Toast></Toast> */}
            <div className="min-h-full w-full">
                <Navbar isAutoLogOut={false} />
                <div className="flex flex-col lg:flex-row">
                    <div className="flex flex-col lg:flex-row justify-center align-middle">

                        {/* Image Container */}
                        <div className="lg:flex-1 lg:max-w-1/2">
                            <div className="flex justify-center items-center h-full">
                                <img
                                    alt="..."
                                    src={idanCover}
                                    style={{ objectFit: 'cover' }}
                                    className={`${imageLoaded ? 'opacity-100' : 'opacity-0'} rounded-sm transition-all duration-150 `}
                                    onLoad={handleImageLoad}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:px-12 mx-auto lg:flex-1 lg:max-w-1/2">

                        <div className="container-component">
                            <div className="login-header">
                                <div className='flex justify-end align-middle'>
                                    <div className='flex text-6xl text-blue-700 dark:text-gray-50 font-bold py-2text-right'>כניסה</div>
                                </div>
                                <div className='text-gray-500 text-right dark:text-gray-200'>ברוך שובך , בבקשה הזן את פרטייך</div>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="login-container">
                                    <div> Email: </div>
                                    <input
                                        className="input-component"
                                        placeholder="user@company.com"
                                        type="text"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="login-container">
                                    <div> password: </div>
                                    <input
                                        className="input-component"
                                        placeholder="••••••••"
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <div className="flex items-start mb-6">
                                    <div className="flex items-center h-5">
                                        <input type="checkbox" defaultChecked={remember} value={remember} onClick={(e) => setRemember(!remember)} className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800" />
                                    </div>
                                    <label className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Remember me</label>
                                </div>
                                <button className="button-component mb-3" type="submit">Log In</button>

                                <div className="container flex justify-center align-middle mb-5">
                                    <div className='text-sm text-gray-500 dark:text-gray-300'>Forgot your password?</div>
                                    <div className='text-sm text-blue-600 dark:text-blue-500 hover:underline px-2 hover:cursor-pointer' onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/resetpswd') }}> Reset Password
                                    </div>
                                </div>

                                <div className="container flex ustify-center items-center flex-col w-full">
                                    <div ref={gsiButton}></div>
                                </div>
                            </form>
                            <div className="container flex ustify-center items-center py-5 w-full">
                                <button
                                    onClick={(e) => { e.preventDefault(); navigate('/') }}
                                    className="w-full inline-flex justify-center text-sm items-center py-2 font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                                    <svg className=" mr-2 -ml-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" strokeWidth="1.5" stroke="currentColor" ><path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" /></svg>
                                    חזרה
                                </button>
                            </div>
                            <div className="container flex justify-center align-middle flex-row-reverse">

                                <div className='text-sm text-gray-500 dark:text-gray-300'>?עדיין אין חשבון</div>
                                <div className='text-sm text-blue-600 dark:text-blue-500 hover:underline px-2 hover:cursor-pointer' onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/signup') }}> להרשמה
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Login;